// src/types/index.ts

import { type RemixiconComponentType } from "~/icons/remix"
import { type SVGProps } from "react"


// Feature types
export interface Feature {
  id: string
  name: string
  description: string
  icon: RemixiconComponentType
  details?: string
  benefits?: string[]
}

export interface FeatureTab {
  id: string
  title: string
  description: string
  icon: RemixiconComponentType
  imageSrc: string
  imageAlt: string
  blurDataUrl: string
}

// Icon types
export type IconSvgProps = SVGProps<SVGSVGElement> & {
  size?: number
}

// Pricing types
export type FixedPrice = string

export interface VariablePrice {
  monthly: string
  annually: string
}

export interface Plan {
  name: string
  price: FixedPrice | VariablePrice
  description: string
  capacity: string[]
  features: string[]
  isStarter: boolean
  isRecommended: boolean
  buttonText: string
  buttonLink: string
}

export interface PricingFeature {
  name: string
  plans: Record<string, boolean | string>
  tooltip?: string
}

export interface PricingSection {
  name: string
  features: readonly PricingFeature[]
}

export type Theme = "light" | "dark" | "system"

export interface ThemeAwareProps {
  initialTheme: Theme
  resolvedTheme?: Theme
}